import { render, staticRenderFns } from "./StudentChanger.vue?vue&type=template&id=f3954722"
import script from "./StudentChanger.vue?vue&type=script&lang=js"
export * from "./StudentChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3954722')) {
      api.createRecord('f3954722', component.options)
    } else {
      api.reload('f3954722', component.options)
    }
    module.hot.accept("./StudentChanger.vue?vue&type=template&id=f3954722", function () {
      api.rerender('f3954722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/StudentChanger.vue"
export default component.exports